export default {
    set(key, value) {
        window.localStorage.setItem(key, value);
    },
    setBoolean(key: string, value: boolean): void {
        window.localStorage.setItem(key, !!value ? "true" : "false");
    },
    get(key: string) {
        return window.localStorage.getItem(key);
    },
    getBoolean(key: string): boolean {
        return window.localStorage.getItem(key) === "true";
    },
    delete(key) {
        window.localStorage.removeItem(key);
    },
    getAllKeys() {
        return Object.keys(window.localStorage);
    },
    setInt(key, value) {
        if (parseInt(value, 10) !== value) {
            throw Error("Not int: " + value);
        }

        window.localStorage.setItem(key, value);
    },
    /**
     * Default 0 if not in storage.
     */
    getInt<T extends number | null = number>(key: string, defaultValue: T = 0 as T): number | T {
        const value = window.localStorage.getItem(key);

        if (value === null) {
            return defaultValue;
        }

        return parseInt(value, 10);
    },

    getArray<T>(key: string): T[] {
        const value = window.localStorage.getItem(key);

        if (value === null) {
            return [];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            console.error("Failed to parse JSON from localStorage:", e);
            return [];
        }
    },
    setArray<T>(key: string, value: T[]): void {
        const asString = JSON.stringify(value);
        window.localStorage.setItem(key, asString);
    },

    getObject<T>(key: string): T | null {
        const value = window.localStorage.getItem(key);

        if (value === null) {
            return null;
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            console.error("Failed to parse JSON from localStorage:", e);
            return null;
        }
    },
    setObject<T>(key: string, value: T): void {
        const asString = JSON.stringify(value);
        window.localStorage.setItem(key, asString);
    },

    getString(key: string, defaultValue: string | undefined = undefined): string | undefined {
        const value = window.localStorage.getItem(key);
        return value === null ? defaultValue : value;
    },
    setString(key: string, value: string | undefined): void {
        if (value === undefined) {
            window.localStorage.removeItem(key);
            return;
        }

        window.localStorage.setItem(key, value);
    },
};
